import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Box, Button, ListItem, OrderedList, Text } from "@chakra-ui/react";
import React, { useState } from "react";

export default function PaymentKliring() {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Button w="full" variant="ghost" onClick={() => setOpen(!open)}>
        <Box w="full" textAlign="left">
          Pembayaran Dari Kliring Bank Lain
        </Box>
        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Button>
      {open && (
        <OrderedList px="5" spacing={2}>
          <ListItem>
            Pilih <b>“Transfer ke Bank Lain”</b>
          </ListItem>
          <ListItem>
            Pilih <b>“Bank BPD Bali”</b> sebagai bank tujuan.
          </ListItem>
          <ListItem>
            Masukkan nomor rekening tujuan <b> (No Virtual Account)</b>.
          </ListItem>
          <ListItem>
            Input <b>nominal</b> yang ingin ditransfer sesuai <b>tagihan</b>{" "}
            yang ingin dibayar. Mohon dipastikan nominal yang akan ditransfer
            sama dengan jumlah tagihan yang harus dibayar agar proses bisa
            berjalan sukses.
          </ListItem>
          <ListItem>Lanjutkan transaksi.</ListItem>
          <ListItem>Selesai</ListItem>
          <Text>
            Note : tata cara tiap bank mungkin ada sedikit berbeda namun secara
            gambaran umum sama seperti penjelasan diatas.
          </Text>
        </OrderedList>
      )}
    </Box>
  );
}
